// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3Hl8H","inputDescription":"styles_inputDescription__3nqVp"};